<template>
  <v-menu offset-y :close-on-content-click="false">
    <template #activator="{ on, attrs }">
      <v-btn class="white-button" v-bind="attrs" block v-on="on">
        <v-icon class="mr-2"> mdi-email-outline </v-icon>
        Enviar por correo
      </v-btn>
    </template>
    <v-card color="white" class="pa-2">
      <v-form
        ref="emailForm"
        :disabled="disabled || loading"
        @submit.prevent="emitEmail"
      >
        <label>Ingresa tu correo</label>
        <v-text-field
          v-model="email"
          class="mt-2"
          placeholder="ejemplo@ejemplo.com.mx"
          outlined
          dense
          :rules="emailRules"
          :loading="loading"
        />
        <div class="d-flex justify-end">
          <v-btn
            class="red-button mt-n3"
            placeholder="ejemplo@ejemplo.com.mx"
            type="submit"
            small
            dark
            :disabled="disabled || loading"
          >
            {{ loading ? 'Enviando correo' : 'Enviar' }}
          </v-btn>
        </div>
      </v-form>
    </v-card>
  </v-menu>
</template>

<script>
  /* eslint-disable vue/require-default-prop, vue/require-prop-types */
  import commonFormRules from '@/mixins/commonFormRules';

  export default {
    name: 'ClearanceMaterialsModal',

    mixins: [commonFormRules],
    props: {
      value: {
        type: String,
      },

      loading: Boolean,
      disabled: Boolean,
    },

    computed: {
      email: {
        set(newValue) {
          this.$emit('input', newValue);
        },
        get() {
          return this.value;
        },
      },
    },

    methods: {
      async emitEmail() {
        const formRef = this.$refs.emailForm;

        if (formRef.validate()) {
          this.$emit('onFormSubmit', this.email);
        }
      },
    },
  };
</script>
